<template>
    <div class="page bgF6F6F6 lineHeight1p375">

        <div class="imageArea" style="height: 255px;">
            <img class="block fullSpace" :src="dataItem ? dataItem.coverImg : ''"/>
        </div>

        <div class="prepayInfo" style="height: 62px; background: url('coursePrepay/prepay_info_bg.svg') -1px 0 no-repeat;
            background-size: 100% 100%; background-size: cover;">
            <div class="generalPagePaddingH flexLayout">
                <div class="flexItem" style="color: #FFF5F5; ">
                    <div class="font12r" style="line-height: 2.9em;">
                        预售价&nbsp;&nbsp;
                        ￥<span style="font-size: 233.3%">{{dataItem ? dataItem.price || 0 : 0}}</span>
                    </div>
                    <div>
                        <span class="textDelete font12r">原价 ￥{{dataItem ? dataItem.marketPrice || 0 : 0}}</span>
                    </div>
                </div>
                <div class="flexItem timeCountDown alignR" style="padding-top: 8px; color: #FFF5F5"
                     v-show="getActivityStatus() === 'ready' || getActivityStatus() === 'march'">
                    <div v-show="getActivityStatus() === 'ready'">距活动开始仅剩</div>
                    <div v-show="getActivityStatus() === 'march'">距活动时间结束仅剩</div>
                    <div class="bold">
                        {{countDown.day}}天
                        <span class="textLabel">{{countDown.hour}}</span>：
                        <span class="textLabel">{{countDown.minute}}</span>：
                        <span class="textLabel">{{countDown.second}}</span>
                    </div>
                </div>
                <div v-show="getActivityStatus() === 'closed'">
                    活动已结束
                </div>
            </div>
        </div><!-- end .prepayInfo -->

        <div class="white_bg generalPagePaddingH paddingV20 marginB12" v-if="dataItem && dataItem.goActivityInfo">
            <div class="title bold">{{dataItem.title}}</div>
            <div class="font12r color999 marginB8">
                本期预售时间: {{formatDateYMD(dataItem.goActivityInfo.startTime)}}-{{formatDateMD(dataItem.goActivityInfo.endTime)}}
            </div>
            <div class="clearfix marginB20">
                <div class="floatL">
                    <label class="textLabel" v-show="dataItem.goActivityInfo.activityLimitCount">
                        限{{dataItem.goActivityInfo.activityLimitCount}}份，仅剩{{dataItem.goActivityInfo.activityResidueCount}}份
                    </label>
                    <label class="textLabel" v-show="!dataItem.goActivityInfo.activityLimitCount">
                        数量有限，欲购从速
                    </label>
                </div>
                <div class="fr font12r color333" v-show="dataItem.liveCount > 0">
                    共{{dataItem.liveCount}}节课
                </div>
            </div>
            <div class="marginT20 f12 fWeight400" style="line-height: 16px; color: hsla(14, 100%, 63%, 1)"
                @click="$refs.couponDrawer.open();">
                <img class="icon fl size16 marginR12" src="coursePrepay/coupon_icon.svg"/>
                下单即获优惠券
                <img class="fr" width="12" height="12" src="coursePrepay/orange_right_angle_brackets.svg"/>
            </div>
<!--            <div class="font12r color333">-->
<!--                预售福利：在本阶段进行购买，可获得一定金额的抵用券。-->
<!--            </div>-->
        </div>

        <div class="white_bg">
            <div class="tabComp">
                <div class="header">
                    <ul class="menu clearfix noPadding noMargin noListStyle color999 font14r bold">
                        <li class="item" :class="{active : tab.active === '详情'}" @click="tab.active = '详情'">详情</li>
                        <li class="item" :class="{active : tab.active === '课程列表'}" @click="tab.active = '课程列表'">课程列表</li>
                    </ul>
                </div>
                <div class="body">
                    <div class="inner">
                        <!-- 详情内容 -->
                        <div class="article detailContent" v-show="tab.active === '详情'">
                            <div class="alignJustify" v-html="dataItem ? dataItem.introduce : ''"></div>

                            <buyNotice source="course_notice"/>

                        </div><!-- end .detailContent -->

                        <!-- 课程列表 -->
                        <div class="sectionListContent" v-show="tab.active === '课程列表'">
                            <ul class="sectionList noPadding noMargin noListStyle">
                                <li class="item flexLayout flex-between" v-for="segmentItem in (dataItem ? dataItem.segmentList : [])"
                                    :key="segmentItem.id" :data-id="segmentItem.id"
                                    :data-scheduleTime="segmentItem.scheduleTime" @click="viewSegment(segmentItem)">
                                    <div class="segmentInof flex-item">
                                        <div class="title bold">
                                            {{segmentItem.title}}
                                        </div>
                                        <div class="time line1 font10r">
                                            时长{{formatDateSegmentLength(segmentItem.videoLength)}}
                                            <span style="display: none; margin-left: 24px">
                                                {{segmentItem.click}}次播放
                                            </span>
                                        </div>
                                    </div>

<!--                                    <img class="vod fr size28" src="icon/grey_circle_play_button.svg">-->

                                </li>
                            </ul>
                        </div><!-- end .sectionListContent -->
                    </div>
                </div>
            </div>
        </div>

        <div class="bottomOperationArea">
            <div class="inner generalPagePaddingH flexLayout">
                <div class="flexItem">
                    <div class="font14r" style="line-height: 33px;">
                        <strong class="price">￥
                            <span style="font-size: 171.42%">{{dataItem ? dataItem.price || 0 : 0}}</span>
                        </strong>
                        <img class="label" src="icon/book_scramble_coupon.svg" style="margin-left: 4px;"/>
                    </div>
                    <div class="font12r color333 bold">
                        预售价
                    </div>
                </div>
                <div style="width: 160px;">
                    <button class="button block bookButton white f16"
                        v-if="getActivityStatus() === 'ready'">活动未开始</button>
                    <button class="button block bookButton white f16"
                        v-else-if="getActivityStatus() === 'closed'" disabled="">活动已结束</button>
                    <button class="button block bookButton white f16"
                        v-else-if="getActivityStatus() === 'march' && !dataItem.isAuthorized && !dataItem.goActivityInfo.isPay" @click="goToBuy">马上预订</button>
                    <button class="button block bookButton white f16"
                        v-else-if="getActivityStatus() === 'march' && (dataItem.isAuthorized || dataItem.goActivityInfo.isPay)" @click="goToLearn()">已购买</button>

                </div>
            </div>
        </div>

        <a class="fixedBackIcon" href="javascript:;" @click="back()">
            <img class="icon" src="icon/back_icon.svg"/>
        </a>

        <distributeButton orderBizType="GO_ACTIVITY" @sharePoster="sharePoster()"/>

        <coursePayDialog ref="payDialog" type="prepay" :onPaySuccess="onPaySuccess"/>
        <obtainCouponDialog ref="obtainCouponDialog"
            :onOk="onOkObtainCouponDialog" :onClose="onCloseObtainCouponDialog"/>

        <couponDrawer ref="couponDrawer"/>

    </div><!-- end .page -->
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import moment from 'moment';

// modules
import coursePayDialog from '@comp/vodCourse/coursePayDialog';
import obtainCouponDialog from '@comp/coupon/obtainCouponDialog';
import couponDrawer from './couponDrawer';
import buyNotice from '@comp/contentModule/buyNotice';
import distributeButton from '@/components/distribution/distributeButton';

// data
import bizTypeEnum from '@/data/bizTypeEnum';

// api
import timerManager from '@comp/platformApi/timerManager';
import requestManager from '@comp/platformApi/requestManager';
import browsingApi from '@api/browsing';

// config
import appConfig from '../../appConfig';

// util
import consoleHelper from '@util/consoleHelper';
import stringHelper from '@util/stringHelper';
import htmlHelper from '@util/htmlHelper';
import urlHelper from '@util/urlHelper';
import objectHelper from '@util/objectHelper';
import wechatHelper from '@util/wechatHelper';
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        get : {
            url : '/portal/vod/v2/',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "coursePrepay",
    extends : shixunPagePart,
    components : {
        coursePayDialog, obtainCouponDialog,
        couponDrawer, buyNotice, distributeButton
    },
    data () {
        return {
            apiConfig : config.apiConfig,
            tab : {
                active : '详情'
            },
            timer : null,
            countDown : {
                day : 0,
                hour : 0,
                minute : 0,
                second : 0,
            },
            user : null
        }
    },
    methods : {
        back: function() {
            appHelper.back(this)
        },
        onLoadDataItem() {

            if (this.dataItem.goActivityInfo)
            {
                this.$refs.couponDrawer.updateDataList({
                    activityId : this.dataItem.goActivityInfo.id
                });

                // test obtainCouponDialog
                // this.$refs.obtainCouponDialog.updateDataList({
                //     activityId : this.dataItem.goActivityInfo.id
                // });
            }

            this.setWechatShare();

            let timeRange = '活动时间：';
            timeRange += moment(this.dataItem.goActivityInfo.startTime).format('YYYY-MM-DD HH:mm:ss');
            timeRange += ' 至 ';
            timeRange += moment(this.dataItem.goActivityInfo.endTime).format('YYYY-MM-DD HH:mm:ss');
            consoleHelper.log(timeRange);

            if (this.inActivityTimeRange())
            {
                this.initTimer();
            }
        },
        goToLearn() {
            appHelper.redirect('/learn/course/' + this.dataItem.id)
        },
        formatDateYMD : function (timestamp) {
            return moment(timestamp).format('YYYY.MM.DD');
        },
        formatDateMD : function (timestamp) {
            return moment(timestamp).format('MM.DD');
        },
        formatDateSegmentLength(seconds) {
            let second = seconds % 60;
            let minute = (seconds - second) / 60;
            let txt = minute + '分' + second + '秒';
            return txt;
        },
        viewSegment(segmentItem) {
            if (this.dataItem.isAuthorized || this.dataItem.goActivityInfo.isPay)
            {
                this.goToLearn();
            }
            else
            {
                appHelper.showHint('购买立即查看');
            }
        },
        initTimer() {
            const me = this;
            this.timer = timerManager.setInterval(() => {
                me.updateCountDown();
            }, 300);
        },
        /**
         * @return {string} 'ready'|'march'|'closed'
         */
        getActivityStatus() {
            if (!this.dataItem) // not loaded data
            {
                return 'ready';
            }

            const nowSeconds = new Date().getTime();

            if (nowSeconds < this.dataItem.goActivityInfo.startTime)    // 未开始
            {
                return 'ready';
            }
            if (nowSeconds < this.dataItem.goActivityInfo.endTime)    // 进行中
            {
                return 'march';
            }
            else
            {
                return 'closed';
            }
        },
        /**
         * @return {boolean}
         */
        inActivityTimeRange() {
            return this.getActivityStatus() === 'march';
        },
        updateCountDown() {

            // seconds
            let now = new Date().getTime();
            let seconds = 0;
            if (now < this.dataItem.goActivityInfo.startTime)   // 还没开始
            {
                seconds = Math.floor((this.dataItem.goActivityInfo.startTime - now) / 1000);
            }
            else if (now <= this.dataItem.goActivityInfo.endTime)    // 活动进行中
            {
                seconds = Math.floor((this.dataItem.goActivityInfo.endTime - now) / 1000);
            }
            else    // 已结束
            {
                this.countDown.second =
                this.countDown.minute =
                this.countDown.hour =
                this.countDown.day = '00';
                return;
            }

            this.countDown.second   = seconds % 60;
            this.countDown.minute   = Math.floor(seconds / 60) % 60;
            this.countDown.hour     = Math.floor(seconds / 60 / 60) % 24;
            this.countDown.day      = Math.floor(seconds / 60 / 60 / 24);

            // fix
            this.countDown.second >= 10 ? null : this.countDown.second = '0' + this.countDown.second;
            this.countDown.minute >= 10 ? null : this.countDown.minute = '0' + this.countDown.minute;
            this.countDown.hour >= 10 ? null : this.countDown.hour = '0' + this.countDown.hour;
            this.countDown.day >= 10 ? null : this.countDown.day = '0' + this.countDown.day;

            // consoleHelper.log(this.countDown.day + ' day ' +
            //     this.countDown.hour + ' hour ' +
            //     this.countDown.minute + ' minute ' +
            //     this.countDown.second + ' second'
            // );
        },
        goToBuy : function () {
            this.$refs.payDialog.setProduct({
                id : this.dataItem ? this.dataItem.goActivityInfo.id : '',
                title : this.dataItem ? this.dataItem.title : '',
                image : this.dataItem ? this.dataItem.coverImg : '',
                price : this.dataItem ? this.dataItem.price : '',
                bizType : bizTypeEnum.PRE_PAY.code
            });
            this.$refs.payDialog.open();
        },
        onPaySuccess : function () {

            const me = this;

            appHelper.showHint('购买成功');

            if (this.dataItem.goActivityInfo)
            {
                this.$refs.obtainCouponDialog.updateDataList({
                    activityId : this.dataItem.goActivityInfo.id
                });
            }

            this.$refs.payDialog.hide();

            // reload data
            window.setTimeout(() => {
                me.loadDataItem(me.dataItem.id);
            }, 1000);
        },
        onOkObtainCouponDialog() {
            this.hide();
            this.$parent.reloadDataItem();
        },
        onCloseObtainCouponDialog() {
            this.hide();
            this.$parent.reloadDataItem();
        },
        recordBrowse(options = {}) {

            let promotionCode = options.promotionCode || '';
            let id = options.id || '';

            let requestOptions = objectHelper.clone(browsingApi.transmitBrow);
            requestOptions.data = {
                id: id,
                bizType: 'VOD',
                promotionCode: promotionCode
            };
            requestManager.request(requestOptions, (error) => {
                if (error)
                {
                    consoleHelper.logError(error);
                    return;
                }
            });
        },
        setWechatShare() {

            let desc = this.dataItem.introduce;
            desc = htmlHelper.removeTag(desc);
            desc = htmlHelper.decode(desc);

            let link = '';
            if (!this.user)
            {
                link = appHelper.generateShareUrl('/course/coursePrepay/' + this.dataItem.id);
            }
            else
            {
                link = appHelper.generateShareUrl('/course/coursePrepay/:id/promotion/:promotionCode', {
                    ':id' : this.dataItem.id,
                    ':promotionCode' : this.user.introduceCode
                });
            }

            let title = '';
            if (this.dataItem.firstCategoryName)
            {
                title += '【' + this.dataItem.firstCategoryName + '】';
            }

            title += '《' + this.dataItem.title + '》优惠提前购';

            const wechatShareOptions = {
                title: title, // 分享标题
                desc: desc || '立刻学习', // 分享描述
                link: link,
                imgUrl: this.dataItem ? this.dataItem.coverImg : appHelper.getAppIcon(), // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
            };

            wechatHelper.setShare(wechatShareOptions);
        },

        sharePoster() {
            if (typeof(this.$refs.shareDrawer) === 'undefined')
            {
                this.share();
                return;
            }

            this.$refs.shareDrawer.init({
                id: this.dataItem.id
            });
        },

    },
    /**
     * init processing:
     * load data item -> check login -> set wechat share url
     */
    mounted() {

        const id              = this.$route.params.id || '';
        const promotionCode   = this.$route.params.promotionCode || '';

        if (promotionCode)
        {
            this.recordBrowse({
                promotionCode : promotionCode,
                id : id
            });
        }

        const me = this;

        if (appConfig.mode == 'demo')
        {
            this.dataItem = {
                id : id,
                title : '',
                // createTime : new Date().getTime() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 7),
                coverImg : appHelper.getRandomCoverImage(),
                userHead : appHelper.getRandomUserHead(),
            };
        }
        else {
            appHelper.checkLogin(function (user)
            {
                me.user = user;
                me.loadDataItem(id);
            }, {
                promotionCode : promotionCode
            });
        }

        // this.$refs.obtainCouponDialog.show();
    },
    beforeRouteLeave : function (to, form, next) {
        if (this.timer)
        {
            timerManager.clearInterval(this.timer);
            this.timer = null;
        }
        next();
    },
    watch: {

        $route (to, from) {

            // 同页面不同参数需要使用函数加载新数据
            if (to.name === from.name)
            {
                const id = to.params.id || '';
                this.$route.params.id = id;

                this.dataItem = {};
                this.loadDataItem(id);
                window.scrollTo(0,0);
            }
            // this.$router.go(0)  // 安卓下会刷新页面，微信下会回到旧地址，苹果下无法跳转
        }
    }
}
</script>

<style lang="scss" scoped>
.textLabel {
    border: solid 1px #F55050;
    color: #F55050;
    background: #FFF5F5;
    padding: 0px 2px;
}
.tabComp {
    .header {
        .menu {
            .item {
                position: relative;
                float: left;
                padding: 14px 16px;

                &.active {
                    color: #333;

                    &:before {
                        content : '';
                        display: block;
                        position: absolute;
                        width: 18px;
                        height: 2px;
                        background: #F55050;
                        bottom: 6px;
                        left: 50%;
                        margin-left: -9px;
                    }
                }
            }
        }
    }
    .body {
        .inner {
            padding: 16px 18px;
        }
    }
}

.introduction {
    padding: 10px 0 18px;
}
.introduction .title {
    position: relative;
    padding-left: 12px;
}
.introduction .title:before {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    height: 14px;
    background: #F55050;
    top: 5px;
    left: 0;
}
.introduction p {
    margin-bottom: 12px;
}
.timeCountDown .textLabel {
    background-color: #FFBA43;
    border: none;
    color: white;
    padding: 0 4px;
}
.detailContent {
    display: block;
    overflow: hidden;
    img {
        max-width: 100%;
    }
}

.sectionListContent {
    .sectionList {
        margin-top: .1rem;
        .flex-item {
            flex: 1;
        }
        .item {
            position: relative;
            padding: 10px 12px;
            background-color: #F9F9F9;
            border-radius: 4px;
            margin-bottom: 8px;

            &:last-child {
                border-bottom: 0
            }

            .title {
                /*width: 14rem;*/
                margin-bottom: .3rem;
                overflow: hidden;
                line-height: 1.5em;
                max-height: 3em;
                padding-right: 10px;
            }
            &.active .title {
                color: #0097FE;
                font-weight: 500
            }
            .time {
                color: #888
            }
            .tryBtn span {
                display: inline-block;
                padding: 5px 8px;
                color: #fff;
                border-radius: 4px;
                background-color: #1090FF
            }
        }
    }
}
.bottomOperationArea {

    height: 82px;
    width: 100%;
    box-sizing: border-box;

    .inner {
        position: fixed;
        height: 82px;
        width: 100%;
        left: 0;
        bottom: 0;
        background-color: white;
        box-sizing: border-box;
        padding-top: 3px;
    }

    .label {
        vertical-align: top;
    }
}
.bookButton {
    /*width: 209px;*/
    display: block;
    width: 100%;
    height: 42px;
    background: linear-gradient(169deg, #FF6434 0%, #FF3452 100%);
    border-radius: 21px;
}

</style>
